import * as React from "react";
import { cn } from "./cn";

// Pill — a state word: pill-radius, soft background, matching text and border in the same hue. A
// bounded set of tones, never free prose (V6.4's enumerated-state rule).
//
// 12px sans with AA text (2026-11-03). It was v1's 10px monospace in the tone colour itself, which
// measured 3.0:1 (ok), 3.1:1 (warn) and 3.8:1 (crit) in the light theme against WCAG AA's 4.5:1 —
// the one element on a screen that says whether something is broken was the hardest to read.

export type PillTone = "ok" | "warn" | "crit" | "accent" | "neutral";

const toneClass: Record<PillTone, string> = {
  ok: "bg-oksoft text-oktext border-[color-mix(in_oklab,var(--ozp-ok)_30%,transparent)]",
  warn: "bg-warnsoft text-warntext border-[color-mix(in_oklab,var(--ozp-warn)_30%,transparent)]",
  crit: "bg-critsoft text-crittext border-[color-mix(in_oklab,var(--ozp-crit)_30%,transparent)]",
  accent: "bg-accentsoft text-accenttext border-[var(--ozp-accent-line)]",
  neutral: "bg-surface3 text-muted border-line2",
};

export function Pill({
  tone = "neutral",
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { tone?: PillTone }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-[2px]",
        "text-[12px] font-medium leading-[18px]",
        toneClass[tone],
        className,
      )}
      {...props}
    />
  );
}
